import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'time' })
export class TimePipe implements PipeTransform {
	transform(value: string, showMintues: boolean = false): string {
		if (value) {
			const hour = value.substring(0, 2);
			const minutes = value.substring(3, 5);
			if (minutes === '00' && !showMintues) {
				return `${hour}u`;
			} else return `${hour}u${minutes}`;
		} else return '';
	}
}
